import { SchoolCollection, ZoneCollection } from '../types';

/**
 * Loads school location data from GeoJSON file
 */
export async function loadSchools(): Promise<SchoolCollection> {
  try {
    const response = await fetch('/data/schools.geojson');
    if (!response.ok) {
      throw new Error(`Failed to load schools data: ${response.statusText}`);
    }
    const data = await response.json();
    return data as SchoolCollection;
  } catch (error) {
    console.error('Error loading schools data:', error);
    throw error;
  }
}

/**
 * Loads school zone boundary data from GeoJSON file
 */
export async function loadZones(): Promise<ZoneCollection> {
  try {
    const response = await fetch('/data/zones.geojson');
    if (!response.ok) {
      throw new Error(`Failed to load zones data: ${response.statusText}`);
    }
    const data = await response.json();
    return data as ZoneCollection;
  } catch (error) {
    console.error('Error loading zones data:', error);
    throw error;
  }
}

/**
 * Loads both schools and zones data concurrently
 */
export async function loadAllData(): Promise<{
  schools: SchoolCollection;
  zones: ZoneCollection;
}> {
  try {
    const [schools, zones] = await Promise.all([
      loadSchools(),
      loadZones()
    ]);
    
    return { schools, zones };
  } catch (error) {
    console.error('Error loading map data:', error);
    throw error;
  }
} 